/*
*@Author: dcl
*@Description: 动态地图
*@Date: 2022-11-28 16:59:45
*/
<template>
<div ref="echarts">

</div>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios'
import chinaSvg from '../assets/china.svg'
export default {
    data() {
        return {

        }
    },
    mounted() {
        // var chartDom = document.getElementById('echarts')
        var myChart = echarts.init(this.$refs.echarts)
        var option = {}
        axios(chinaSvg).then(res => {
            echarts.registerMap('china', {
                svg: res.data
            })
            option = {
                tooltip: {},
                geo: {
                    tooltip: {
                        show: true
                    },
                    map: 'china',
                    roam: 'scale'
                },
                series: {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    geoIndex: 0,
                    tooltip: {
                        formatter: function (params) {
                            return `${params.data[3]}<br />地址：${params.data[4]}<br />电话：${params.data[5]}`
                        }
                    },
                    symbolSize: function (params) {
                        return (params[2] / 100) * 15 + 5
                    },
                    itemStyle: {
                        color: '#3158A6'
                    },
                    data: [
                        [1028, 419, 40, '辽宁分公司', '辽宁省沈阳市沈河区东陵路36号', '024-88459198'],
                        [890, 450, 40, '北京分公司', '北京市大兴区黄村镇清源路40号1幢平房', '010-53792755'],
                        [865, 500, 40, '河北分公司', '河北省石家庄市桥西区振岗路156号石家庄市汽车贸易园桥西区销售中心（南区）D5-B号二层', '0311-68099798'],
                        [805, 550, 40, '山西分公司', '晋中开发区鸣李汽贸园（汇盛日产汽车服务公司）', '0354-2465335'],
                        [940, 580, 40, '山东分公司', '济宁高新区327国道北、同济大道东东风日产东源专营店', '0537-2989003'],
                        [990, 650, 40, '江苏分公司', '扬州市邗江区荷叶东路160号1', '0514-80971700'],
                        [1030, 698, 40, '上海分公司', '浦东新区航头镇沈杜公路118号2幢104室', '021-58089508'],
                        [1000, 780, 40, '浙江分公司', '浙江省杭州市拱墅区半山街道北秀街455号（拥铁和光仓储中心）2幢2-2', '0571-56036685'],
                        [835, 720, 40, '湖北分公司', '湖北省武汉市蔡甸区沌口小区海天汽配大世界西区29栋158号3楼', '027-84851699'],
                        [850, 910, 60, '广州分公司', '广州市天河区博汇街6号3栋110房-1', '020-66357638'],
                        [873, 945, 40, '深圳分公司', '深圳市福田区福田街道福南社区福明路42号福华多层停车库701', '0755-86112327'],
                        [835, 950, 40, '茂名分公司', '茂名市茂南区环市西路文岭村委会12巷1号厂房101室', '0668-33936000'],
                        [880, 920, 40, '东莞分公司', '广东省东莞市南城街道莞太路南城段383号', '0769-22985916'],
                        [600, 730, 40, '四川分公司', '成都市双流区东升街道龙桥路188号2栋1层1号', '028-85688818'],
                        [710, 745, 40, '重庆分公司', '重庆市九龙坡区石新路220号附1号', '023-68881350'],
                        [690, 850, 40, '贵州分公司', '贵州省贵阳市南明区花溪大道北段448号众福家园裙楼半负2层2A号房【湘雅社区】', '0851-83759701'],
                        [550, 910, 40, '云南分公司', '云南省昆明市五华区二环西路559号', '0871-68327333'],
                        [730, 930, 40, '广西分公司', '柳州市柳南区广西汽车贸易园汇轮路3号柳州航盛航宇汽车销售服务有限公司二楼办公室', '0772-2805355'],
                        [755, 1050, 40, '海南分公司', '海南省海口市美兰区琼山大道292号东方日产展厅', '0898-65961304']
                    ]
                }
            }
            myChart.setOption(option)
        })
        myChart.getZr().on('click', function (params) {
            var pixelPoint = [params.offsetX, params.offsetY];
            var dataPoint = myChart.convertFromPixel({
                geoIndex: 0
            }, pixelPoint)
            // console.log(dataPoint);
        })
        // option && myChart.setOption(option)
    },
}
</script>

<style scoped lang='less'>

</style>



// WEBPACK FOOTER //
// src/components/DynamicMap.vue